<template>
  <div class="setItem fadeInRight">
    <el-form ref="addForm" style="max-height: 500px; overflow-y: scroll">
      <el-table :data="tableList" style="margin-top: 15px">
        <el-table-column label="百分比" prop="" min-width="90">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.percent"  :min="0" :max="100" :step="1" step-strictly label="百分比"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="150">
          <template slot-scope="scope">
            <el-button
              type="danger"
              plain
              size="mini"
              :disabled="tableList.length==1"
              @click="deleteParams(scope.row, scope.$index)"
              >删除</el-button
            >
            <el-button
              type="info"
              plain
              size="mini"
              :disabled="isDisable"
              @click="afterAddParams(scope.row, scope.$index)"
              >插入一行</el-button
            >
          </template>
        </el-table-column>
      </el-table>
     
      <span></span>
      <div class="align-right">
        <el-button type="primary" class="themed-button" @click="cancle"
          >取消</el-button
        >
        <el-button type="primary" class="themed-button" @click="sure"
          >确认</el-button
        >
      </div>
    </el-form>
  
  </div>
</template>

<script>
import resize from "@/mixins/resize.js";
import { messageBox, confirmBox } from "@/utils/common.js";
export default {
  name: "setItem",
  mixins: [resize],
  props: ["curPercent"],
  data() {
    return {
      tableList: [
       
      ],
      currentTable:this.curPercent
    };
  },
  created() {
    console.log(this.currentTable,typeof(this.currentTable))
     if(!this.currentTable){
      this.tableList.push({
        percent: 100,
      });
    } else if (this.currentTable.length > 0 && this.currentTable!="undefined") {
        // "80;90;99"
        console.log(this.currentTable)
         this.currentTable = this.currentTable + ";";
         let arr = this.currentTable.split(";");
          console.log(arr)
          arr.forEach(item=>{
            console.log(item)
            if(item!=""){
             this.tableList.push({
              percent: item,
            })
            }
          })

     
    } else {
      this.tableList.push({
       percent: 100,
      });
    }
  },
  computed: {
    isDisable() {
      if (this.tableList.length >= 3) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    deleteParams(data, index) {
      
      this.tableList.splice(parseInt(index), 1);
    },
    afterAddParams(data, index) {
    this.tableList.splice(parseInt(index)+1,0,{ percent:100,})
    },
    cancle() {
      this.$emit("cancel");
    },

    sure() {
      //校验
      console.log(this.tableList,this.tableList.length)
      if (this.tableList.length > 0) {
        let value = "";
        var arr = this.tableList
        console.log(arr)
        for(var i =0;i<arr.length-1;i++){
           if(arr[i].percent==arr[i+1].percent ){
             messageBox(this, "重复设置百分比");
            return;
           }
        }
        for (let i of arr) {
          
          value += i.percent + ";";
        }
        value = value.substring(0, value.length - 1);
        console.log(value);
        this.$emit("close", value);
      }
    },
  },
};
</script>

<style>
.setItem .el-form-item__label {
  vertical-align: top;
}
.setItem .inputWidth {
  width: 50%;
}
</style>